let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8TITE")).then(() => parcelRequire('7WEsL'));